import { UserIdentity } from "../../models/user-identity.model";

export interface LawNavItem {
    id?: string
    name?: string,
    readonly displayName?: string;
    orc?: string,
    readonly uri?: string,
    readonly updatedDate?: string,
    readonly updatedBy?: string
}

export class LawItem implements LawNavItem {

    id?: string;
    name?: string;
    orc?: string;
    readonly uri?: string;
    readonly updatedDate?: string;
    readonly updatedBy?: string;

    get displayName(): string {
        return this.getShortenedName();
    }

    constructor(data: LawNavItem) {
        this.id = data.id;
        this.name = data.name;
        this.orc = data.orc;
        this.uri = data.uri;
        this.updatedDate = data.updatedDate;
        this.updatedBy = data.updatedBy;
    }

    getShortenedName(): string {
        if (this.name) {
            return this.name.replace(this.orc, "").replace("OAC", "").replace("ORC", "");
        }
        else {
            return "";
        }
    }
}

export type Law = LawNavItem & { data: string }